import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import AboutSection from './components/AboutSection';
import TrendingSection from './components/TrendingSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hipobuyspread.buzz';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Hipobuy Spreadsheet',
  url: siteUrl,
  description: 'The ultimate spreadsheet resource hub for smarter product discovery. Browse organized product categories, comparison guides, and expert shopping resources.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Hipobuy Spreadsheet',
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
    },
  },
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <AboutSection />
        <TrendingSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}